import { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { connect } from 'react-redux';

import Icon from 'components/atoms/Icon';
import Image from 'components/atoms/Image';
import MenuGroup from 'components/atoms/MenuGroup';
import ToggleButton from 'components/atoms/ToggleButton';
import { bindActionCreators, Dispatch } from 'redux';
import {
    SetLayerControlsAction,
    setLayerControlsAction,
    SetLayoutAction,
    setLayoutAction,
    setSwitchAction,
} from 'store/actions/layoutActions';
import { setPilotagePlansAction } from 'store/actions/portActions';
import { Layout, OpenModal, PlanType, PortAreaType, PortType, RootState, SwitchType, UserType } from 'types';
import { MainControlsInterface, MapControlsInterface, TogglePlanInterface } from 'types/functions';
import { checkDifferent, clone, getId } from 'utils/formHandlers';
import { hasPermission } from 'utils/permission';
import { translate } from 'utils/translate';
import { twclsx } from 'utils/twclsx';

interface LayersMenuComponentProps {
    switchs: SwitchType;
    layout: Layout;
    active: boolean;
    mode: string;
    port: PortType;
    outlineInterval: number;
    mainControls: MainControlsInterface;
    pilotagePlans: PlanType[];
    setPilotagePlansAction: (plans: PlanType[]) => void;
    setLayerControlsAction: SetLayerControlsAction;
    setLayoutAction: SetLayoutAction;
    setSwitchAction: (key: string, value: object) => void;
    openModelFunction: OpenModal;
    mapControls: MapControlsInterface;
    user: UserType;
}

interface LayersMenuComponentState {
    layout: Layout;
    active: boolean;
    switchs: SwitchType;
    portAreas: PortAreaType[];
    outlineInterval: number;
    mode: string;
    port: PortType | null;
    pilotagePlans: PlanType[];
}

class LayersMenu extends Component<LayersMenuComponentProps, LayersMenuComponentState> {
    constructor(props: LayersMenuComponentProps) {
        super(props);
        this.state = {
            mode: 'search',
            layout: clone(props.layout),
            switchs: clone(props.switchs),
            port: props.port,
            portAreas:
                props.port.port_areas?.map((x) => {
                    return { ...x, visable: this.getPortAreaFeatureVisiblity(x) };
                }) || [],
            active: props.active,
            outlineInterval: props.outlineInterval,
            pilotagePlans: props.pilotagePlans,
        };
    }

    static getDerivedStateFromProps(props: LayersMenuComponentProps, state: LayersMenuComponentState) {
        if (
            checkDifferent(props.port, state.port) ||
            checkDifferent(props.layout, state.layout) ||
            props.active !== state.active ||
            props.mode !== state.mode ||
            props.outlineInterval !== state.outlineInterval ||
            checkDifferent(
                Object.fromEntries(
                    Object.entries(props.switchs).filter(([key, value]) => {
                        return value.mode === props.mode || value.mode === 'all';
                    })
                ),
                Object.fromEntries(
                    Object.entries(state.switchs).filter(([key, value]) => {
                        return value.mode === props.mode || value.mode === 'all';
                    })
                )
            ) ||
            checkDifferent(props.pilotagePlans, state.pilotagePlans)
        ) {
            return {
                outlineInterval: props.outlineInterval,
                active: props.active,
                mode: props.mode,
                layout: clone(props.layout),
                switchs: Object.fromEntries(
                    Object.entries(props.switchs).filter(([key, value]) => {
                        return value.mode === props.mode || value.mode === 'all';
                    })
                ),
                pilotagePlans: props.pilotagePlans,
            };
        }
        return null;
    }

    // componentDidMount(): void {
    //     this.props.setLayerControlsAction({
    //         togglePlan: this.togglePlan,
    //     });
    // }

    toggleAnalysisArea = (key, value) => {
        this.props.setSwitchAction(key, { loading: true });
        setTimeout(() => {
            // code to add later
            this.props.setSwitchAction(key, { loading: false, value });
        }, 500);
    };

    toggleMetOcean = (key, value) => {
        this.props.setSwitchAction(key, { loading: true });
        setTimeout(() => {
            // code to add later
            this.props.setSwitchAction(key, { loading: false, value });
        }, 500);
    };

    toggleTransitDisplay = (key, value) => {
        this.props.setSwitchAction(key, { loading: true });
        setTimeout(() => {
            setTimeout(() => {
                // code to add later
                switch (key) {
                    case 'vesselOutline':
                        this.props.mainControls.updateDrawVesselOutline(0, value);
                        break;
                    case 'vesselTracks':
                        this.props.mainControls.updateDrawTrack(0, value);
                        break;
                    case 'sweptPath':
                        this.props.mainControls.updateDrawSweptPath(0, value);
                        break;
                    case 'vesselOutColor':
                        this.props.mainControls.updateDrawVesselOutline(0, this.state.switchs.vesselOutline.value);
                        break;
                    default:
                        break;
                }
                this.props.setSwitchAction(key, { loading: false, value });
            }, 600);
        }, 100);
    };

    toggleLayerDisplay = (key, value) => {
        this.props.setSwitchAction(key, { loading: true });
        setTimeout(() => {
            this.props.setSwitchAction(key, { loading: false, value });
        }, 200);
    };

    togglePlan: TogglePlanInterface = (key: string | undefined): void => {
        // Update the plan to set loading to true
        this.props.setPilotagePlansAction(
            this.state.pilotagePlans.map((plan) => (plan.key === key ? { ...plan, loading: true } : plan))
        );

        setTimeout(() => {
            this.props.setPilotagePlansAction(
                this.state.pilotagePlans.map(
                    (plan) =>
                        plan.key === key ? { ...plan, value: !plan.value, loading: false } : { ...plan, value: false } // Set value to false for all other plans
                )
            );
        }, 500);
    };

    showPilotagePlanSetting = () => {
        this.props.openModelFunction(
            'pilotagePlansSettingsModel',
            0,
            'small',
            {},
            {
                onCancel: () => {
                    this.props.openModelFunction('pilotagePlansSettingsModel');
                },
            },
            true
        );
    };

    createPlanSetting = (plan: PlanType) => {
        return [
            {
                key: getId(),
                name: 'Routes',
                disabled: plan.route === '',
                type: 'route',
                options: [plan.route],
            },
            {
                key: getId(),
                name: 'Reference points',
                value: true,
                type: 'wayPoint',
                disabled: plan.markerPoints.length === 0,
                options: plan.markerPoints,
            },
            {
                key: getId(),
                name: 'XTDs',
                disabled: plan.XTD === '',
                type: 'xtd',
                options: [plan.XTD],
            },
            {
                key: getId(),
                name: 'Safety margins',
                disabled: plan.safetyMargins.length === 0,
                type: 'reservedAreas',
                options: plan.safetyMargins,
            },
            {
                key: getId(),
                name: 'NoGoArea',
                disabled: plan.noGoAreas.length === 0,
                type: 'reservedAreas',
                options: plan.noGoAreas,
            },
        ];
    };

    showPilotagePlanFeatures = (plan: PlanType) => {
        this.props.openModelFunction(
            'planFeatureModel',
            0,
            'medium',
            {
                pilotagePlanSetting: this.createPlanSetting(plan),
                plan,
            },
            {
                onCancel: () => {
                    this.props.openModelFunction('planFeatureModel');
                },
                onConfirm: () => {
                    //console.log('saved');
                },
            },
            true
        );
    };

    openlayerSetting = (layer: string) => {
        this.props.openModelFunction(
            `${layer}SettingModel`,
            0,
            'small',
            {
                layer,
            },
            {
                onCancel: () => {
                    this.props.openModelFunction(`${layer}SettingModel`, 0);
                },
            },
            true
        );
    };

    getGroupState = (section: string): boolean => {
        switch (this.state.mode) {
            case 'search':
                return this.state.layout.sections.chart.menus.layersMenu.sections[section].state || false;
            case 'playback':
                return this.state.layout.sections.playback.menus.layersMenu.sections[section].state || false;
            case 'time':
            case 'live':
                return this.state.layout.sections.time.menus.layersMenu.sections[section].state || false;
        }
        return false;
    };

    setGroupState = (section: string, state: boolean) => {
        switch (this.state.mode) {
            case 'search':
                this.props.setLayoutAction([
                    {
                        action: 'UPDATE_MENU_SECTION',
                        data: {
                            menu: 'layersMenu',
                            section: 'chart',
                            name: section,
                            state: true,
                            selected: state,
                        },
                    },
                ]);

                break;
            case 'playback':
                this.props.setLayoutAction([
                    {
                        action: 'UPDATE_MENU_SECTION',
                        data: {
                            menu: 'layersMenu',
                            section: 'playback',
                            name: section,
                            state: true,
                            selected: state,
                        },
                    },
                ]);

                break;
            case 'time':
            case 'live':
                this.props.setLayoutAction([
                    {
                        action: 'UPDATE_MENU_SECTION',
                        data: {
                            menu: 'layersMenu',
                            section: 'time',
                            name: section,
                            state: true,
                            selected: state,
                        },
                    },
                ]);

                break;
        }
        return false;
    };

    togglePortArea = (portArea: PortAreaType) => {
        this.setState({
            portAreas: this.state.portAreas.map((x) => {
                return { ...x, visable: x.id === portArea.id ? !x.visable : x.visable };
            }),
        });
        switch (this.state.mode) {
            case 'search':
                this.props.mapControls.chart?.portAreaFeatureVisiblity(
                    [portArea.name],
                    portArea.type,
                    !portArea.visable,
                    true
                );
                break;
            case 'playback':
                this.props.mapControls.playback?.portAreaFeatureVisiblity(
                    [portArea.name],
                    portArea.type,
                    !portArea.visable,
                    true
                );
                break;
            case 'time':
            case 'live':
                this.props.mapControls.time?.portAreaFeatureVisiblity(
                    [portArea.name],
                    portArea.type,
                    !portArea.visable,
                    true
                );
                break;
        }
    };

    getPortAreaFeatureVisiblity = (portArea): any => {
        switch (this.props.mode) {
            case 'search':
                return this.props.mapControls.chart?.portAreaFeatureVisiblity([portArea.name], portArea.type) || {visible : false};
            case 'playback':
                return (
                    this.props.mapControls.playback?.portAreaFeatureVisiblity([portArea.name], portArea.type) || {visible : false}
                );
            case 'time':
            case 'live':
                return this.props.mapControls.time?.portAreaFeatureVisiblity([portArea.name], portArea.type) || {visible : false};
        }
        return false;
    };

    render() {
        return (
            <div
                className={twclsx(
                    this.state.active ? 'left-0 ' : 'left-out',
                    'mt-14',
                    'h-page',
                    'border-r',
                    'border-gray-300',
                    'position-transition',
                    'fixed',
                    'z-20',
                    'w-smallMenu',
                    'ml-subMenu',
                    'h-page',
                    'top-0',
                    'bg-white'
                )}
            >
                <div className="flex justify-between border-b border-gray-300 py-3  px-2">
                    <div className="text-lg font-bold">{translate('Chart display')}</div>
                    {/*hash close menu 'x'*/}
                    {/* <div
                        onClick={() => {
                            this.props.setLayoutAction([
                                {
                                    action: 'UPDATE_MENU',
                                    data: {
                                        name: 'layers',
                                        section: 'chart',
                                        state: false,
                                    },
                                },
                                {
                                    action: 'UPDATE_MENU',
                                    data: {
                                        name: 'layers',
                                        section: 'time',
                                        state: false,
                                    },
                                },
                                {
                                    action: 'UPDATE_MENU',
                                    data: {
                                        name: 'layers',
                                        section: 'playback',
                                        state: false,
                                    },
                                },
                            ]);
                        }}
                        className="cursor-pointer"
                    >
                        <Icon>
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M18 6l-12 12" />
                            <path d="M6 6l12 12" />
                        </Icon>
                    </div> */}
                </div>
                <Scrollbars autoHide className="w-full h-menu">
                    <div>
                        {/*remove pilotagePlans to menu */}

                        {/* {this.state.pilotagePlans && (
                            <>
                                {this.state.pilotagePlans.length === 0 && (
                                    <MenuGroup title={`${translate('Safety margins')}`}>
                                        {this.state.portAreas
                                            .filter((portArea: PortAreaType) => {
                                                return portArea.type === 'reservedAreas';
                                            })
                                            .map((portArea) => {
                                                return (
                                                    <div key={portArea.id} className="flex items-center gap-1 py-1">
                                                        <ToggleButton
                                                            onChange={() => this.togglePortArea(portArea)}
                                                            value={portArea.visable || false}
                                                        />

                                                        <div className="flex justify-between items-start w-full">
                                                            <div>{portArea.name}</div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                    </MenuGroup>
                                )}
                                {this.state.pilotagePlans.length === 0 && (
                                    <MenuGroup title={`${translate('NoGo areas')}`}>
                                        {this.state.portAreas
                                            .filter((portArea: PortAreaType) => {
                                                return portArea.type === 'noGoAreas';
                                            })
                                            .map((portArea) => {
                                                return (
                                                    <div key={portArea.id} className="flex items-center gap-1 py-1">
                                                        <ToggleButton
                                                            onChange={() => this.togglePortArea(portArea)}
                                                            value={portArea.visable || false}
                                                        />

                                                        <div className="flex justify-between items-start w-full">
                                                            <div>{portArea.name}</div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                    </MenuGroup>
                                )}
                                {this.state.pilotagePlans.length >= 1 && (
                                    <MenuGroup
                                        settings={this.showPilotagePlanSetting}
                                        title={`${translate('Pilotage plans')}`}
                                    >
                                        {this.state.pilotagePlans.map((plan) => {
                                            return (
                                                <div key={plan.key} className="flex items-center gap-1 py-1">
                                                    {plan.loading ? (
                                                        <Image
                                                            alt="loading"
                                                            className="w-4 mx-1"
                                                            src="/static/images/loading.svg"
                                                        ></Image>
                                                    ) : (
                                                        <ToggleButton
                                                            onChange={() => this.togglePlan(plan.key)}
                                                            value={plan.value || false}
                                                        />
                                                    )}
                                                    <div className="flex justify-between items-start w-full">
                                                        <div>{plan.name}</div>
                                                        {plan.value && (
                                                            <div
                                                                className="cursor-pointer"
                                                                onClick={() => {
                                                                    this.showPilotagePlanFeatures(plan);
                                                                }}
                                                            >
                                                                <Icon className="w-4 h-4">
                                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                                    <path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                                                                    <path d="M12 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                                                                    <path d="M12 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                                                                </Icon>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </MenuGroup>
                                )}
                            </>
                        )} */}
                        {((this.state.layout.sections.chart.menus.layersMenu.sections.analysisAreas.state &&
                            this.state.layout.sections.chart.state) ||
                            (this.state.layout.sections.playback.menus.layersMenu.sections.analysisAreas.state &&
                                this.state.layout.sections.playback.state) ||
                            (this.state.layout.sections.time.menus.layersMenu.sections.analysisAreas.state &&
                                this.state.layout.sections.time.state)) && (
                                <MenuGroup
                                    extrnal
                                    callback={(state: boolean) => {
                                        this.setGroupState('analysisAreas', state);
                                    }}
                                    active={this.getGroupState('analysisAreas')}
                                    title={`${translate('Analysis areas')}`}
                                    open
                                >
                                    {Object.keys(this.state.switchs)
                                        .filter((key) => {
                                            return this.state.switchs[key].section === 'analysisAreas';
                                        })
                                        .map((key) => {
                                            return (
                                                <div key={key} className="flex items-center gap-1 py-1">
                                                    {this.state.switchs[key].loading ? (
                                                        <Image
                                                            alt="loading"
                                                            className="w-4 mx-1"
                                                            src="/static/images/loading.svg"
                                                        ></Image>
                                                    ) : (
                                                        <ToggleButton
                                                            onChange={() =>
                                                                this.toggleAnalysisArea(key, !this.state.switchs[key].value)
                                                            }
                                                            value={this.state.switchs[key].value}
                                                        />
                                                    )}
                                                    {/*className="capitalize"*/}
                                                    <div>{translate(this.state.switchs[key].label)}</div>{' '}
                                                </div>
                                            );
                                        })}
                                </MenuGroup>
                            )}

                        {((this.state.layout.sections.chart.menus.layersMenu.sections.manoeuvreInformation.state &&
                            this.state.layout.sections.chart.state) ||
                            (this.state.layout.sections.playback.menus.layersMenu.sections.manoeuvreInformation.state &&
                                this.state.layout.sections.playback.state) ||
                            (this.state.layout.sections.time.menus.layersMenu.sections.manoeuvreInformation.state &&
                                this.state.layout.sections.time.state)) && (
                                <MenuGroup
                                    extrnal
                                    callback={(state: boolean) => {
                                        this.setGroupState('manoeuvreInformation', state);
                                    }}
                                    active={this.getGroupState('manoeuvreInformation')}
                                    title={`${translate('Manoeuvre information')}`}
                                    open
                                >
                                    {Object.keys(this.state.switchs)
                                        .filter((key) => {
                                            return this.state.switchs[key].section === 'manoeuvreInformation';
                                        })
                                        .map((key) => {
                                            return (
                                                <div key={key} className="flex items-center gap-1 py-1">
                                                    {this.state.switchs[key].loading ? (
                                                        <Image
                                                            alt="loading"
                                                            className="w-4 mx-1"
                                                            src="/static/images/loading.svg"
                                                        ></Image>
                                                    ) : (
                                                        <ToggleButton
                                                            onChange={() =>
                                                                this.toggleAnalysisArea(key, !this.state.switchs[key].value)
                                                            }
                                                            value={this.state.switchs[key].value}
                                                        />
                                                    )}
                                                    {/*className="capitalize"*/}
                                                    <div>{translate(this.state.switchs[key].label)}</div>
                                                </div>
                                            );
                                        })}
                                </MenuGroup>
                            )}
                        {((this.state.layout.sections.chart.menus.layersMenu.sections.enviromentalData.state &&
                            this.state.layout.sections.chart.state) ||
                            (this.state.layout.sections.playback.menus.layersMenu.sections.enviromentalData.state &&
                                this.state.layout.sections.playback.state) ||
                            (this.state.layout.sections.time.menus.layersMenu.sections.enviromentalData.state &&
                                this.state.layout.sections.time.state)) && (
                                <MenuGroup
                                    extrnal
                                    callback={(state: boolean) => {
                                        this.setGroupState('enviromentalData', state);
                                    }}
                                    active={this.getGroupState('enviromentalData')}
                                    title={`${translate('Enviromental data')}`}
                                    open
                                >
                                    {Object.keys(this.state.switchs)
                                        .filter((key) => {
                                            return this.state.switchs[key].section === 'enviromentalData';
                                        })
                                        .map((key) => {
                                            return (
                                                <div key={key} className="flex items-center gap-1 py-1">
                                                    {this.state.switchs[key].loading ? (
                                                        <Image
                                                            alt="loading"
                                                            className="w-4 mx-1"
                                                            src="/static/images/loading.svg"
                                                        ></Image>
                                                    ) : (
                                                        <ToggleButton
                                                            onChange={() =>
                                                                this.toggleAnalysisArea(key, !this.state.switchs[key].value)
                                                            }
                                                            value={this.state.switchs[key].value}
                                                        />
                                                    )}
                                                    {/*className="capitalize"*/}
                                                    <div>{translate(this.state.switchs[key].label)}</div>
                                                </div>
                                            );
                                        })}
                                </MenuGroup>
                            )}
                        {((this.state.layout.sections.chart.menus.layersMenu.sections.transitDisplay.state &&
                            this.state.layout.sections.chart.state) ||
                            (this.state.layout.sections.playback.menus.layersMenu.sections.transitDisplay.state &&
                                this.state.layout.sections.playback.state) ||
                            (this.state.layout.sections.time.menus.layersMenu.sections.transitDisplay.state &&
                                this.state.layout.sections.time.state)) && (
                                <MenuGroup
                                    callback={(state: boolean) => {
                                        this.setGroupState('transitDisplay', state);
                                    }}
                                    extrnal
                                    active={this.getGroupState('transitDisplay')}
                                    title={`${translate('Transit display')}`}
                                    open
                                >
                                    <div className="mb-2">
                                        {Object.keys(this.state.switchs)
                                            .filter((key) => {
                                                return this.state.switchs[key].section === 'dataDisplay';
                                            })
                                            .filter((key) => {
                                                if (
                                                    key === 'identifyTransits' &&
                                                    !hasPermission(this.props.user, this.props.port.id, ['obscureDisplay'])
                                                ) {
                                                    return false;
                                                }
                                                return true;
                                            })
                                            .filter((key) => {
                                                return (
                                                    this.state.switchs[key].mode === this.props.mode ||
                                                    this.state.switchs[key].mode === 'all'
                                                );
                                            })
                                            .map((key) => {
                                                return (
                                                    <div key={key} className="flex items-center gap-1 py-1">
                                                        {this.state.switchs[key].loading ? (
                                                            <Image
                                                                alt="loading"
                                                                className="w-4 mx-1"
                                                                src="/static/images/loading.svg"
                                                            ></Image>
                                                        ) : (
                                                            <ToggleButton
                                                                disabled={
                                                                    key === 'vesselOutColor' &&
                                                                        !this.state.switchs['vesselOutline'].value
                                                                        ? true
                                                                        : false
                                                                }
                                                                onChange={() =>
                                                                    this.toggleTransitDisplay(
                                                                        key,
                                                                        !this.state.switchs[key].value
                                                                    )
                                                                }
                                                                value={this.state.switchs[key].value}
                                                            />
                                                        )}
                                                        {/*className="capitalize"*/}
                                                        <div>{translate(this.state.switchs[key].label)}</div>
                                                    </div>
                                                );
                                            })}
                                        {Object.keys(this.state.switchs)
                                            .filter((key) => {
                                                return this.state.switchs[key].section === 'aggregationLayers';
                                            })
                                            .filter((key) => {
                                                return (
                                                    this.state.switchs[key].mode === this.props.mode ||
                                                    this.state.switchs[key].mode === 'all'
                                                );
                                            })
                                            .map((key) => {
                                                return (
                                                    <div key={key} className="flex justify-between items-center py-1">
                                                        <div className="flex items-center gap-1 ">
                                                            {this.state.switchs[key].loading ? (
                                                                <Image
                                                                    alt="loading"
                                                                    className="w-4 mx-1"
                                                                    src="/static/images/loading.svg"
                                                                ></Image>
                                                            ) : (
                                                                <ToggleButton
                                                                    onChange={() =>
                                                                        this.toggleLayerDisplay(
                                                                            key,
                                                                            !this.state.switchs[key].value
                                                                        )
                                                                    }
                                                                    value={this.state.switchs[key].value}
                                                                />
                                                            )}
                                                            <div className="capitalize">
                                                                {translate(this.state.switchs[key].label)}
                                                            </div>
                                                        </div>
                                                        <div
                                                            onClick={() => {
                                                                this.openlayerSetting(key);
                                                            }}
                                                            className="cursor-pointer"
                                                        >
                                                            <Icon className="w-4 h-4">
                                                                <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"></path>
                                                                <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"></path>
                                                            </Icon>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        {this.state.mode === 'search' && (
                                            <div className="flex items-center gap-2 py-1 cursor-pointer leading-5 text-gray-700  hover:text-primary-500 focus:outline-none focus:bg-gray-100 focus:text-primary-500">
                                                <Icon>
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                                                    <path d="M12 7v5l3 3" />
                                                </Icon>
                                                <div
                                                    onClick={() => {
                                                        this.props.openModelFunction(
                                                            'changeIntervalModel',
                                                            0,
                                                            'medium',
                                                            {
                                                                outlineInterval: this.state.outlineInterval,
                                                            },
                                                            {
                                                                onCancel: () => {
                                                                    this.props.openModelFunction('changeIntervalModel');
                                                                },
                                                                onConfirm: () => {
                                                                    //console.log('saved');
                                                                },
                                                            },
                                                            true
                                                        );
                                                    }}
                                                >
                                                    {translate('interval every', {
                                                        everySeconds: this.state.outlineInterval,
                                                    })}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </MenuGroup>
                            )}
                        {((this.state.layout.sections.chart.menus.layersMenu.sections.metOceanData.state &&
                            this.state.layout.sections.chart.state) ||
                            (this.state.layout.sections.playback.menus.layersMenu.sections.metOceanData.state &&
                                this.state.layout.sections.playback.state) ||
                            (this.state.layout.sections.time.menus.layersMenu.sections.metOceanData.state &&
                                this.state.layout.sections.time.state)) && (
                                <MenuGroup
                                    extrnal
                                    callback={(state: boolean) => {
                                        this.setGroupState('metOceanData', state);
                                    }}
                                    active={this.getGroupState('metOceanData')}
                                    title={`${translate('metOcean data')}`}
                                    open
                                >
                                    {Object.keys(this.state.switchs)
                                        .filter((key) => {
                                            return this.state.switchs[key].section === 'metOcean';
                                        })
                                        .map((key) => {
                                            return (
                                                <div key={key} className="flex items-center gap-1 py-1">
                                                    {this.state.switchs[key].loading ? (
                                                        <Image
                                                            alt="loading"
                                                            className="w-4 mx-1"
                                                            src="/static/images/loading.svg"
                                                        ></Image>
                                                    ) : (
                                                        <ToggleButton
                                                            onChange={() =>
                                                                this.toggleMetOcean(key, !this.state.switchs[key].value)
                                                            }
                                                            value={this.state.switchs[key].value}
                                                        />
                                                    )}
                                                    {/*className="capitalize"*/}
                                                    <div>{translate(this.state.switchs[key].label)}</div>
                                                </div>
                                            );
                                        })}
                                </MenuGroup>
                            )}
                    </div>
                </Scrollbars>
            </div>
        );
    }
}

const layersMenuStateToProps = (state: RootState) => ({
    switchs: state.layout.switchs,
    port: state.port.port,
    layout: state.layout.layout,
    mode: state.layout.mode,
    pilotagePlans: state.port.pilotagePlans,
    outlineInterval: state.map.outlineInterval,
    openModelFunction: state.layout.openModelFunction,
    mapControls: state.map.mapControls,
    mainControls: state.layout.mainControls,
    user: state.user.user,
});
const layersMenuDispatchToProps = (dispatch: Dispatch) => ({
    setSwitchAction: bindActionCreators(setSwitchAction, dispatch),
    setPilotagePlansAction: bindActionCreators(setPilotagePlansAction, dispatch),
    setLayerControlsAction: bindActionCreators(setLayerControlsAction, dispatch),
    setLayoutAction: bindActionCreators(setLayoutAction, dispatch),
});

export default connect(layersMenuStateToProps, layersMenuDispatchToProps)(LayersMenu);
